<template>
  <div class="w-100 h-100">
    <div
      class="form-background relative"
      v-if="loaded && !loading && !programLoading"
    >
      <!-- data card -->
      <DataCard
        style="position:fixed;bottom:0;right:0;z-index:3000"
        :showDataCardButton="screen == 'form' && !showDataCard"
        :showDataCard="
          sentCellphone == '' &&
            showDataCard &&
            isParticipant &&
            screen == 'form'
        "
        :showDataCardSent="user.type == 'student'"
        :sentCellphone="sentCellphone"
        @setSentCellphone="setSentCellphone"
      />
      <!-- background -->
      <div>
        <canvas class="green-circle" v-if="screen != 'form'" />
        <canvas class="purple-shape" v-if="screen != 'form'" />
        <canvas class="red-shape" v-if="screen != 'form'" />
      </div>
      <img class="form-logo mt-10" src="@/assets/Dashboard/Logo.svg" />
      <responsive-div desktop-class="form-logout" class="mt-10">
        <common-button
          @click="logout"
          style="position:absolute;right:20px;top:20px"
          icon
          v-if="mobile"
          ><v-icon>mdi-logout-variant</v-icon></common-button
        >
        <common-button @click="logout" v-else>Cerrar sesión</common-button>
      </responsive-div>

      <!-- logout -->

      <!-- consent dialog -->
      <custom-dialog
        :width="mobile ? '90%' : '70%'"
        height="90vh"
        v-model="showConsentDialog"
        extraStyles="background: #EEF0FF; "
        closeIconStyles="display: none"
      >
        <v-title><b>Asentimiento Informado</b> </v-title>
        <v-card
          class="text-left p-2 pe-4"
          style="max-height: 50vh;height:50vh; overflow-y:auto"
          v-html="consentText"
        >
        </v-card>
        <b class="text-left"
          >Luego de leer, por favor, indique si desea participar:</b
        >
        <v-radio-group class="ml-10" v-model="isParticipant">
          <v-radio color="#576aff" label="Sí, deseo participar" :value="true" />
          <v-radio
            color="#576aff"
            label="No, no quiero participar"
            :value="false"
          />
        </v-radio-group>
        <common-button
          :disabled="isParticipant === null"
          text="Siguiente"
          size="x-large"
          @click="nextScreen(isParticipant)"
        />
      </custom-dialog>
      <!-- end consent dialog -->
      <!-- no particiapte dialog -->
      <custom-dialog
        width="70%"
        height="400"
        v-model="showAreYouSure"
        extraStyles="background: #EEF0FF; padding: 7%;position:relative;"
        closeIconStyles="display: none"
      >
        <b> ¿Estás seguro que no quieres participar?</b><br />
        <br />
        Responder “No” implica que tus credenciales de acceso quedarán
        desactivadas a partir de este momento y no podrás participar de las
        actividades del programa.
        <responsive-div mobileClass="d-flex flex-column">
          <common-button
            style=""
            class="yes-button"
            text="Si quiero participar"
            size="x-large"
            @click="clickAreYouSure(true)"
          />
          <common-button
            style=""
            class="no-button"
            borderStyle="2px solid #5669FB !important"
            primaryColor="#5669FB"
            secondaryColor="transparent"
            text="No quiero participar"
            size="x-large"
            @click="clickAreYouSure(false)"
          />
        </responsive-div>
      </custom-dialog>
      <!-- end no participate dialog -->
      <!-- content -->
      <div class="form-content h-100 pt-5 text-left">
        <!-- welcome -->
        <div v-if="screen == 'welcome'">
          <div v-if="user.type == 'student'">
            <div class="text-heading">¡Comencemos!</div>
            Estamos felices de iniciar la primera etapa:
            <b> ¡Tiempo de Encuesta! </b> <br />
            <br />
            En esta etapa, deberás responder una encuesta que nos permitirá
            conocer tus expectativas de la educación y el impacto que puede
            tener en tu vida. <br />
            <br />
            Te pedimos contestar con la máxima honestidad todas las preguntas
            que te presentamos a continuación. Tus respuestas son
            confidenciales. Nadie de tu institución podrá asociar sus respuestas
            con tu nombre.
          </div>
          <div
            v-else-if="
              user.type == 'principal' ||
                user.type == 'teacher' ||
                user.type == 'manager'
            "
          >
            <div class="text-heading">
              Estimado
              {{
                user.type == "teacher"
                  ? "docente"
                  : "rector o encargado de sede"
              }},
            </div>
            Muchas gracias por su participación.<br />
            Su escuela ya se encuentra en la Etapa 1 del Proyecto Decidiendo
            para un Futuro Mejor. <br />
            En el siguiente cuadro le entregamos un cronograma de las
            actividades y las fechas para llevar a cabo cada una de las etapas
            del programa:
            <br />
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr class="bg--primary bold">
                    <th class="text-left color--neutral-100-t">
                      Actividad
                    </th>
                    <th class="text-left color--neutral-100-t">
                      Fecha de inicio
                    </th>
                    <th class="text-left color--neutral-100-t bo">
                      Fecha de término
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in dates"
                    :key="index"
                    :class="
                      index % 2 == 0
                        ? 'bold bg--primary-60-t'
                        : 'bold bg--primary-90-t'
                    "
                  >
                    <td>{{ item.activity }}</td>
                    <td>{{ item.startDate }}</td>
                    <td>{{ item.endDate }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <br />
            Cualquier duda o consulta, puede escribir al correo:
            <a href="mailto: decidiendofuturomejor@consiliumbots.com"
              >decidiendofuturomejor@consiliumbots.com</a
            >
            <br />
            <span v-if="user.type != 'teacher'"
              >Les adjuntamos los materiales disponibles del programa:</span
            >
            <br />
            <br />
            <div
              v-if="user.type != 'teacher'"
              class="d-flex text-center w-100"
              style="gap: 10px"
            >
              <a
                href="https://drive.google.com/uc?export=download&id=1OYGPaNVdaJ-Q5oLqfJ9EGBcOssU96_3t"
                download="Instructivo_DFM.pdf"
                style="color:white;text-decoration:none"
                ><common-button
                  class="w-100 mt-1 text-label"
                  text="Instructivo Colombia"
                ></common-button
              ></a>
              <a
                href="https://drive.google.com/uc?export=download&id=1SS3mADvr65-ZS12sA-VmVhl4p8887Yh-"
                download="Socialización_DFM.pdf"
                style="color:white;text-decoration:none"
                ><common-button
                  class="w-100 mt-1 text-label"
                  text="Socialización DFM"
                ></common-button
              ></a>
              <a
                href="https://drive.google.com/uc?export=download&id=19az3egih1BoR9uaRCsbq6mQ30Txy3p55"
                download="Resumen_Ejecutivo_DFM.pdf"
                style="color:white;text-decoration:none"
                ><common-button
                  class="w-100 mt-1 text-label"
                  text="Resumen Ejecutivo DFM"
                ></common-button
              ></a>
            </div>
          </div>
          <div class="w-100 text-center">
            <common-button
              text="Siguiente"
              v-if="user.type == 'student'"
              class="mt-5"
              size="x-large"
              @click="showConsentDialog = true"
            />
          </div>
        </div>
        <!-- form -->
        <div v-else-if="screen == 'form'">
          <div class="text-heading">
            Por favor contesta las preguntas que te haremos a continuación
          </div>
          <br />
          <div class="form-container pe-2">
            <!--<custom-select label="Colegio:" v-model="newSchool" required :items="['Colegio 1','Colegio 2']"></custom-select>-->
            <!-- <custom-select label="Género:" v-model="newGenre" required :items="['Femenino','Masculino']"></custom-select>
            <custom-select label="Documento:" v-model="newDocument" required :items="['Cédula','Pasaporte']"></custom-select>
            <custom-field label="Cédula:" v-model="newID" required  ></custom-field>
            <br>-->
            <b>
              Comenzaremos con algunas preguntas acerca de lo que piensas sobre
              tu educación. Las siguientes preguntas se refieren a tu percepción
              sobre tus estudios. En esta encuesta no hay respuestas buenas ni
              malas, solo nos interesa conocer tu opinión.
            </b>
            <br />
            <br />
            <div v-for="(question, index) in formData" :key="index">
              <v-divider />
              <div v-if="question.question">
                <b>{{ index + 1 }}. </b
                ><span
                  :class="question.type == 'multiple-range' ? 'bold' : 'bold'"
                  v-html="question.question"
                ></span>
              </div>
              <div
                v-if="question.instructions"
                class="ml-3 mt-4"
                v-html="question.instructions"
              ></div>
              <!-- question type -->
              <div v-if="question.type == 'single-alternative'">
                <v-radio-group
                  class="ml-5"
                  @change="
                    setValue(question.variable, formAnswers[question.variable])
                  "
                  v-model="formAnswers[question.variable]"
                >
                  <v-radio
                    v-for="(answer, _index) in question.answers"
                    :key="_index"
                    color="#576aff"
                    :label="answer"
                    :value="answer"
                  />
                </v-radio-group>
              </div>
              <!-- question type -->
              <div
                v-if="question.type == 'multiple-alternative' && checkboxLoaded"
              >
                <v-checkbox
                  class="ml-5 form-checkbox"
                  v-for="(answer, _index) in question.answers"
                  :key="_index"
                  @change="
                    setCheckboxValue(
                      answer,
                      question.answers,
                      question['max-answers'],
                      question.variable,
                      _index
                    )
                  "
                  :style="
                    $includes(formAnswers[question.variable], _index)
                      ? '--variable: #576AFF'
                      : ''
                  "
                  :checked="$includes(formAnswers[question.variable], _index)"
                  :label="answer.text"
                  color="#576aff"
                  hide-details
                ></v-checkbox
                ><br />
              </div>
              <!-- question type -->
              <div v-if="question.type == 'bar'">
                <br />
                <v-slider
                  style="width: 85%"
                  class="ml-5 mt-5"
                  :max="question.answers[1]"
                  :min="question.answers[0]"
                  hide-details
                  thumb-label="always"
                  thumb-size="36"
                  @change="
                    setValue(question.variable, formAnswers[question.variable])
                  "
                  v-model="formAnswers[question.variable]"
                  color="var(--primary)"
                >
                  <template v-slot:thumb-label>
                    <div
                      style=" font-size: 15px; background:#576AFF !important;padding:2px;border-radius:2px"
                    >
                      {{
                        format(
                          formAnswers[question.variable],
                          "",
                          question.format
                        )
                      }}
                    </div>
                  </template>
                  <template v-slot:prepend>
                    <span
                      v-if="mobile"
                      style="transform: rotate(-90deg) !important; font-size: 0.7rem"
                    >
                      {{ format(question.answers[0], "", question.format) }}
                    </span>
                    <span v-else>
                      {{ format(question.answers[0], "", question.format) }}
                    </span>
                  </template>
                  <template v-slot:append>
                    <span
                      v-if="mobile"
                      style="transform: rotate(90deg) !important; font-size: 0.7rem"
                    >
                      {{ format(question.answers[1], "max", question.format) }}
                    </span>
                    <span v-else>
                      {{ format(question.answers[1], "max", question.format) }}
                    </span>
                  </template>
                </v-slider>
                <br />
              </div>
              <!-- question type -->
              <div v-if="question.type == 'select'">
                <br />
                <custom-select
                  style="width: 50% !important"
                  class="ml-4"
                  @change="
                    setValue(question.variable, formAnswers[question.variable])
                  "
                  v-model="formAnswers[question.variable]"
                  :items="question.answers"
                ></custom-select>
              </div>
              <!-- question type -->
              <div v-if="question.type == 'multiple-bars'">
                <div
                  v-for="(_question, _index) in question.questions"
                  :key="_index"
                >
                  <br />
                  <div class=" ml-3">
                    {{ index + 1 }}.{{ _index + 1 }} {{ _question.question }}
                  </div>
                  <br />
                  <v-slider
                    style="width: 85%"
                    class="ml-5 mt-5"
                    :max="question.answers[1]"
                    :min="question.answers[0]"
                    hide-details
                    thumb-label="always"
                    @change="
                      setValue(
                        _question.variable,
                        formAnswers[_question.variable]
                      )
                    "
                    thumb-size="36"
                    v-model="formAnswers[_question.variable]"
                    color="var(--primary)"
                  >
                    <template v-slot:thumb-label>
                      <div
                        style="font-size: 15px;background:#576AFF !important;padding:2px;border-radius:2px"
                      >
                        {{
                          format(
                            formAnswers[_question.variable],
                            "",
                            question.format
                          )
                        }}
                      </div>
                    </template>
                    <template v-slot:prepend>
                      <span
                        v-if="mobile"
                        style="transform: rotate(-90deg) !important; font-size: 0.7rem"
                      >
                        {{ format(question.answers[0], "", question.format) }}
                      </span>
                      <span v-else>
                        {{ format(question.answers[0], "", question.format) }}
                      </span>
                    </template>
                    <template v-slot:append>
                      <span
                        v-if="mobile"
                        style="transform: rotate(90deg) !important; font-size: 0.7rem"
                      >
                        {{
                          format(question.answers[1], "max", question.format)
                        }}
                      </span>
                      <span v-else>
                        {{
                          format(question.answers[1], "max", question.format)
                        }}
                      </span>
                    </template>
                  </v-slider>
                </div>
              </div>
              <!-- question type -->
              <div v-if="question.type == 'multiple-range'">
                <div
                  v-for="(_question, _index) in question.questions"
                  :key="_index"
                >
                  <br />
                  <div class="ml-3">
                    {{ index + 1 }}.{{ _index + 1 }} {{ _question.question }}
                  </div>
                  <v-radio-group
                    class="ml-5"
                    @change="
                      setValue(
                        _question.variable,
                        formAnswers[_question.variable]
                      )
                    "
                    v-model="formAnswers[_question.variable]"
                  >
                    <v-radio
                      v-for="(answer, _index) in question.answers"
                      :key="_index"
                      color="#576aff"
                      :label="answer"
                      :value="answer"
                    />
                  </v-radio-group>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="color--error bold">
            Preguntas incompletas: {{ missingQuestionsText }}
          </div>
          <div class="w-100 text-center">
            <common-button
              text="Siguiente"
              :disabled="questionsAnswered.length < 36"
              size="x-large"
              @click="goToEnding"
            />
          </div>
        </div>
        <!-- Ending -->
        <div v-else-if="screen == 'ending'">
          <div v-if="isParticipant">
            <div v-if="user.type == 'student'">
              Muchas gracias por dedicarle tiempo a esta encuesta. Su respuesta
              se ha registrado correctamente. <br />
              {{
                isParticipant && user.has_dfm
                  ? "Durante las próximas semanas se habilitarán las etapas."
                  : ""
              }}
              <!-- Puedes cerrar el navegador y seguir las instrucciones del docente
              a cargo. -->
              <br />
              <b>{{
                isParticipant && user.has_dfm
                  ? "¡Te esperamos en la próxima etapa!"
                  : ""
              }}</b>
            </div>
            <div v-else>
              <div>
                <v-icon class="color--tertiary" x-large style="top: -5px"
                  >mdi-emoticon-excited-outline</v-icon
                >
                <span class="text-title bold"
                  >Muchas gracias por dedicarle tiempo a esta encuesta</span
                >
                <div>
                  Su respuesta se ha registrado correctamente. Puede cerrar el
                  navegador para terminar esta encuesta. Nos pondremos en
                  contacto con usted prontamente.
                </div>
              </div>
              <br />
              <div>
                <v-icon class="color--tertiary" x-large style="top: -5px"
                  >mdi-calendar-month-outline</v-icon
                >
                <span class="text-title bold"
                  >¿Cuál es el cronograma de implementación del programa?</span
                >
                <div>
                  En el siguiente cuadro le entregamos un cronograma preliminar
                  de la actividades y las fechas estimadas para llevar a cabo
                  cada una de las etapas del programa:
                </div>
              </div>
              <br />
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr class="bg--primary bold">
                      <th class="text-left color--neutral-100-t">
                        Actividad
                      </th>
                      <th class="text-left color--neutral-100-t">
                        Fecha de inicio
                      </th>
                      <th class="text-left color--neutral-100-t bo">
                        Fecha de término
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in dates"
                      :key="index"
                      :class="
                        index % 2 == 0
                          ? 'bold bg--primary-60-t'
                          : 'bold bg--primary-90-t'
                      "
                    >
                      <td>{{ item.activity }}</td>
                      <td>{{ item.startDate }}</td>
                      <td>{{ item.endDate }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <br /><br />
            </div>
          </div>
          <div class="text-heading" v-else>
            Gracias por tu tiempo. Te esperamos por acá nuevamente si cambias de
            opinión. Acércate a tu profesor para seguir sus instrucciones.
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="w-100 h-100 d-flex justify-contents-center align-items-center text-heading flex-column"
    >
      <div class="m-auto">
        <v-progress-circular
          indeterminate
          size="70"
          width="10"
          class="me-5"
          color="primary"
        ></v-progress-circular>
        <span>Cargando</span>

        <img class="me-5 ms-5" src="@/assets/Home/DFM.svg" />
      </div>
    </div>
  </div>
</template>
<script>
import DataCard from "@/components/DataCard.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      sentCellphone: "",
      missingQuestions: [],
      loading: true,
      consent: false,
      items: [],
      questionsAnswered: [],
      checkboxLoaded: true,
      loaded: false,
      showConsentDialog: false,
      showAreYouSure: false,
      isParticipant: null,
      answered: null,
      dates: [
        {
          activity: "Inscripción y Etapa 1",
          startDate: "19 de Octubre de 2022",
          endDate: "3 de noviembre de 2022",
        },
        {
          activity: "Resultados Selección",
          startDate: "7 de noviembre",
          endDate: "-",
        },
        {
          activity: "Ejecución: Etapas 2 a 7 (1er turno)",
          startDate: "7 de Noviembre de 2022",
          endDate: "2 de Diciembre de 2022",
        },
        {
          activity: "Ejecución: Etapas 2 a 7 (2do turno)",
          startDate: "Por definir (2023)",
          endDate: "Por definir (2023)",
        },
      ],
      screen: "welcome",
      consentText: `Programa Decidiendo para un Futuro Mejor<br><br></b>DFM consiste en un plan de estudio digital y orientador vocacional gratuito que combate la deserción escolar y promueve la continuidad de estudios superiores. Mediante la entrega de información personalizada, diferentes actividades y herramientas que proporciona el programa, los estudiantes reflexionan sobre la importancia de sus trayectorias educativas y discuten los problemas u obstáculos que podrían enfrentar para acceder a la Educación Superior. Así,  elaboran estrategias y planes que podrían permitirles abordar dichos desafíos con éxito.  <br><br>Con esto se busca fomentar la reflexión informada de los estudiantes sobre la importancia de las trayectorias educativas. Asimismo, la implementación de este programa permitirá generar evidencia sobre sus efectos, contribuyendo de esta manera a mejorar las políticas públicas educativas en Colombia.  <br><br>Al aceptar la participación, usted da su consentimiento para ser parte de las actividades del programa, y que la información recopilada se utilice con fines académicos y/o de investigación. Esta será utilizada con el objeto de contribuir a mejorar las políticas públicas educativas en Colombia y, en particular, en el Valle del Cauca. <b><br><br>Antes de entregar su respuesta, le solicitamos  lea cuidadosamente el texto a continuación: </b><br><br>- Su participación es absolutamente voluntaria, por lo que no hay obligación alguna de participar del programa.  Más aún puede dejar de participar en cualquier momento, no estando obligado a responder pregunta alguna. <br><br>- Su participación en el programa le permitirá acceder al contenido educativo elaborado para informarle sobre la importancia de la educación.<br><br>- Su participación también servirá para generar evidencia sobre cómo mejorar las políticas educativas del Ministerio de Educación de Colombia y, en particular, del Valle del Cauca.<br><br>- Su participación no tendrá ninguna compensación monetaria o material. <br><br>- No hay riesgos asociados a su participación, ni obligación de continuar si se siente incómodo durante alguna actividad del programa. <br><br>- La información recopilada como consecuencia de la implementación del programa es estrictamente confidencial y anónima. <br><br>- Toda la información obtenida será protegida a través de claves de acceso, permitiendo así que solo el equipo que trabaja en el programa pueda revisarlo. Toda la información que se obtenga y permita la identificación de quién está respondiendo será destruida luego de 10 años de finalizado el programa.<br><br>Si tiene preguntas acerca de este programa contactar a <a href = "mailto: equipo@decidiendofuturomejor.com">equipo@decidiendofuturomejor.com</a>`,
      formData: this.$t("form"),
      formAnswers: Object(),
    };
  },
  components: {
    DataCard,
  },
  mounted() {
    // redirect if not user
    if (!this.user) {
      this.$router.push({ name: "home" });
    }
    if (this.user.type == "admin") {
      this.$router.push({ name: "dashboard" });
    }
    if (
      this.$includes(["principal", "teacher"], this.user.type) &&
      this.program
    ) {
      this.$router.push({ name: "dashboard" });
    }

    if (this.user.type != "student") {
      this.screen = "ending";
    }

    // create answer object
    this.formAnswers.name = "";
    this.formAnswers.surname = "";
    this.$t("form").forEach((q) => {
      if (
        this.$includes(
          ["multiple-bars", "multiple-range", "multiple-range"],
          q.type
        )
      ) {
        // this.formAnswers[q.variable] = new Object();
        q.questions.forEach((_q) => {
          this.formAnswers[_q.variable] = "";
        });
      } else if (q.type == "multiple-alternative") {
        this.formAnswers[q.variable] = [];
      } else {
        this.formAnswers[q.variable] = "";
      }
    });
    setTimeout(() => {
      this.setMissingQuestions();
    }, 300);
    this.loaded = true;
    // patch form with baseline_start
    this.patchForm({
      data: {
        answers: {
          baseline_start: this.getDate(),
        },
      },
    });
    // get answers
    this.getForm()
      .then((response) => {
        let jsonResponse = JSON.parse(response.data.answers);

        Object.keys(jsonResponse).forEach((x) => {
          if (x.startsWith("question")) {
            this.questionsAnswered.push(x);
          }
        });
        Object.keys(this.formAnswers).forEach((q) => {
          if (q in jsonResponse) {
            this.formAnswers[q] = jsonResponse[q];
          }
        });
        if ("consent" in jsonResponse) {
          if (jsonResponse.consent == true) {
            this.isParticipant = true;
          } else {
            this.track({
              event: "form-next-screen",
              data: { screen: "welcome" },
            });
            this.screen = "welcome";
          }
        }
        if ("finished" in jsonResponse && jsonResponse.finished) {
          // finished, let's go
          this.consent = true;
          if (this.program != null) {
            // new: only users that have intervention and classes that have dfm
            if (this.user.has_dfm) {
              this.$router.push({ name: "dashboard" });
            }
          }
          this.track({
            event: "form-next-screen",
            data: { screen: "ending" },
          });
          this.screen = "ending";
        } else if ("consent" in jsonResponse) {
          this.loading = false;
          if (jsonResponse["consent"] === false) {
            this.track({
              event: "form-next-screen",
              data: { screen: "welcome" },
            });
            this.screen = "welcome";
          } else if (jsonResponse["consent"] === true) {
            this.track({
              event: "form-next-screen",
              data: { screen: "form" },
            });
            this.screen = "form";
          }
        }
        // add
        if (
          "cellphone" in jsonResponse &&
          jsonResponse["cellphone"].length > 0
        ) {
          this.sentCellphone = jsonResponse["cellphone"];
        }
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  },
  watch: {
    program(newVal) {
      if (
        newVal &&
        (this.consent ||
          this.$includes(["teacher", "principal"], this.user.type))
      ) {
        {
          // new: only classes that have dfm

          // todo: remove
          if (this.user.type != "student") {
            this.$router.push({ name: "dashboard" });
            // new: only classes with dfm
          } else if (this.user.has_dfm) {
            this.$router.push({ name: "dashboard" });
          }
        }
      }
    },
  },
  computed: {
    missingQuestionsText() {
      return this.missingQuestions
        .map((x) => {
          return x.split("-")[1];
        })
        .filter((v, i, a) => a.indexOf(v) === i)
        .join(", ");
    },
    ...mapGetters({
      showDataCard: "authentication/showDataCard",
      programLoading: "program/programLoading",
      mobile: "layout/isMobile",
      user: "authentication/user",
      program: "program/program",
    }),
    answerArray() {
      return Object.keys(this.formAnswers)
        .filter((x) => x.startsWith("question"))
        .map((y) => this.formAnswers[y])
        .filter((x) => x == "" || (Array.isArray(x) && x.length == 0));
    },

    isAnswering() {
      let array = Object.keys(this.formAnswers)
        .filter((x) => x.startsWith("question"))
        .filter(
          (y) =>
            y == "" ||
            (Array.isArray(this.formAnswers[y]) &&
              this.formAnswers[y].length == 0)
        );
      if (array.length > 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    getDate() {
      let yourDate = new Date();
      return yourDate.toISOString().split("T")[0];
    },
    setSentCellphone(val) {
      this.sentCellphone = val;
    },
    ...mapActions({
      getForm: "authentication/getForm",
      patchForm: "authentication/patchForm",
      logout: "authentication/logout",
      track: "authentication/track",
    }),
    setMissingQuestions() {
      this.missingQuestions = Object.keys(this.formAnswers)
        .filter((x) => x.startsWith("question"))
        .filter((x) => {
          return !this.questionsAnswered.includes(x);
        });
    },
    getCheckboxValue(variable, index) {
      return this.$includes(this.formAnswers[variable], index);
    },
    setCheckboxValue(answer, allAnswers, maxAnswers, variable, value) {
      this.checkboxLoaded = false;
      this.$nextTick(() => {
        this.checkboxLoaded = true;
      });
      if (!this.$includes(this.formAnswers[variable], value)) {
        this.formAnswers[variable].push(value);
      } else {
        this.formAnswers[variable] = this.formAnswers[variable].filter(
          (x) => x != value
        );
      }
      if (this.formAnswers[variable].length > maxAnswers) {
        this.formAnswers[variable].shift();
      }
      if (answer.exclusive) {
        this.formAnswers[variable] = this.formAnswers[variable].slice(-1);
      } else {
        allAnswers.forEach((a, index) => {
          if (
            a.exclusive &&
            this.$includes(this.formAnswers[variable], index)
          ) {
            this.formAnswers[variable] = this.formAnswers[variable].filter(
              (x) => x != index
            );
          }
        });
      }
      this.setValue(variable, this.formAnswers[variable]);
    },
    setValue(variable, value) {
      if (Array.isArray(value) && value.length == 0) {
        // quitar en caso de vacio
        if (this.$includes(this.questionsAnswered, variable)) {
          this.questionsAnswered = this.questionsAnswered.filter(
            (x) => x != variable
          );
        }
      } else {
        this.setMissingQuestions();
        // agregar
        if (
          variable.startsWith("question") &&
          !this.$includes(this.questionsAnswered, variable)
        ) {
          this.questionsAnswered.push(variable);
          this.setMissingQuestions();
        }
      }
      this.formAnswers[variable] = value;
      this.patchForm({
        data: {
          answers: {
            [variable]: value,
          },
        },
      });
      this.track({
        event: "form-answer-question",
        data: { answers: this.formAnswers },
      });
    },
    format(value, type, format) {
      if (format == "v-$") {
        var moneyFormatter = new Intl.NumberFormat();
        let x = moneyFormatter.format(value);
        if (type == "max") {
          return `$${x}+`;
        } else {
          return `$${x}`;
        }
      } else if (format == "%") {
        return `${value}%`;
      }
      return value;
    },
    nextScreen(isParticipant) {
      this.patchForm({
        data: {
          answers: {
            isParticipant,
          },
        },
      });
      if (isParticipant) {
        this.track({
          event: "form-next-screen",
          data: { screen: "from" },
        });
        this.screen = "form";
        // send consent
        this.track({
          event: "form-send-consent",
          data: { consent: true },
        });
        this.patchForm({
          data: {
            answers: {
              consent: true,
            },
          },
        });
        this.showConsentDialog = false;
      } else {
        this.showAreYouSure = true;
      }
    },
    goToEnding() {
      this.patchForm({
        data: {
          answers: {
            finished: true,
            baseline_end: this.getDate(),
          },
        },
      });
      this.track({
        event: "form-next-screen",
        data: { screen: "ending" },
      });
      this.screen = "ending";
      if (this.program) {
        // new: only go to dashboard if user has dfm
        if (this.user.type == "student") {
          if (this.user.has_dfm) {
            this.$router.push({ name: "dashboard" });
          }
        } else {
          this.$router.push({ name: "dashboard" });
        }
      }
    },
    clickAreYouSure(value) {
      if (value) {
        this.isParticipant = true;
        this.track({
          event: "form-next-screen",
          data: { screen: "from" },
        });
        this.screen = "form";
      } else {
        this.isParticipant = false;
        this.track({
          event: "form-next-screen",
          data: { screen: "ending" },
        });
        this.screen = "ending";
      }
      this.showAreYouSure = false;
      this.track({
        event: "form-send-consent",
        data: { consent: value },
      });
      this.patchForm({
        data: {
          answers: {
            consent: value,
          },
        },
      });
      this.showConsentDialog = false;
    },
  },
};
</script>
<style>
.form-logo {
  position: absolute;
  left: 150px;
  top: 0px;
  max-height: 60px;
}
.form-logout {
  position: absolute !important;
  right: 150px;
  top: 0px;
}
.yes-button {
  position: absolute !important;
  left: 25px !important;
  bottom: 20px !important;
}
.no-button {
  position: absolute !important;
  right: 25px !important;
  bottom: 20px !important;
}

.form-content {
  position: relative !important;
}
.form-container {
  max-height: 500px;
  overflow-y: auto;
}
.form-background {
  width: 100vw;
  min-height: 100vh;
  height: max-content;
  padding: 10% 17%;
  background: white;
}
.green-circle {
  background: rgba(35, 215, 180, 0.15);
  width: 300px;
  height: 300px;
  border-radius: 100%;
  position: absolute;
  top: 30%;
  left: -3%;
}
.purple-shape {
  background: #5669fb;
  width: 300px;
  height: 300px;
  opacity: 0.15;
  border-radius: 0 0 0 50%;
  position: absolute;
  top: 25%;
  right: -3%;
}
.red-shape {
  background: #ee77d3;
  width: 300px;
  height: 200px;
  opacity: 0.15;
  border-radius: 50% 0 0 0;
  position: absolute;
  bottom: 0;
  right: 15%;
}
.separator {
  height: 1px;
  width: 1px;
  background: black;
  border-radius: 100%;
}
.v-input--selection-controls__input {
  background: var(--variable, default) !important;
  color: var(--variable, default) !important;
  max-width: 10px !important;
  width: 10px !important;
  height: 10px !important;
  max-height: 10px !important;
}
@media (max-width: 700px) {
  .form-logo {
    position: absolute;
    left: 20px;
    top: -15px;
    max-height: 35px;
  }
  .yes-button {
    position: relative;
    bottom: 100px !important;
    left: 25px !important;
    right: 25px !important;
  }
  .no-button {
    position: relative;
    left: 25px !important;
    right: 25px !important;
  }
  .form-background {
    padding: 15% 10%;
  }
  .green-circle {
    width: 100px;
    height: 100px;
    top: 30%;
    left: -3%;
  }
  .purple-shape {
    background: #5669fb;
    width: 100px;
    height: 100px;
    top: 25%;
    right: -3%;
  }
  .red-shape {
    background: #ee77d3;
    width: 100px;
    height: 100px;
    bottom: 0;
    right: 15%;
  }
}
</style>
